import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { normalizeDates } from "./normalizeDates.js";
export function normalizeInterval(context, interval) {
  var _normalizeDates = normalizeDates(context, interval.start, interval.end),
      _normalizeDates2 = _slicedToArray(_normalizeDates, 2),
      start = _normalizeDates2[0],
      end = _normalizeDates2[1];

  return {
    start: start,
    end: end
  };
}